<script>
import helperMethods from '@/helpers'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    props: {
        botResultDataArray: Array,
        select: Function
    },
    components:{
        Card, Button, DataTable, Column
    },
    data(){
        return {
            selectedBot: {}
        }
    },
    computed:{
        totalProfit(){
            const profit = this.botResultDataArray.reduce((acc, item)=>acc+parseFloat(item.valueProfit), 0);
            return profit;
        },
        // maxOpenDeals(){
        //     const dates = Object.keys(this.botResultDataArray[0].openDealsCountByDate);
        //     let max = 0;
        //     dates.forEach((date)=>{
        //         let openDeals = this.botResultDataArray.reduce((acc, item)=>acc + parseInt(item.openDealsCountByDate[date]), 0);
        //         if(max < openDeals) max = openDeals;
        //     })
        //     return max;
        // }
    },
    methods:{
        ...helperMethods,

        onRowSelect(event){
            this.selectedBot = event.data;
            this.select(event.data);
        }
    }
}
</script>

<template>
<div>
    <Card>
        <template #content>
            <h3>Боты</h3>
            <div v-if="botResultDataArray.length > 0">
                <DataTable :value="botResultDataArray" selectionMode="single" dataKey="bot.name" @row-select="onRowSelect" :selection.sync="selectedBot">
                    <Column header="Бот" >
                        <template #body="slotProps">
                            <div>{{slotProps.data.bot.name}}</div>
                            <div>{{slotProps.data.bot.description}}</div>
                        </template>
                    </Column>
                    <Column header="Фрейм" field="timeframe" ></Column>
                    <Column header="Cделок" field="closedDealsCount" ></Column>
                    <Column header="Профиты">
                        <template #body="slotProps">
                            <table>
                            <tr v-for="(data, reason) in slotProps.data.statsByCompleteReason" class="text-sm">
                                <td class="p-1">{{reason}}:</td>
                                <td class="p-1" v-html="round_colored(data.profit, 4)"></td>
                            </tr>
                            </table>
                        </template>
                    </Column>
                    <Column header="Суммарно профит" field="valueProfit" >
                        <template #body="slotProps">
                            <div v-if="slotProps.data.valueProfit">
                                <div v-html="round_colored(slotProps.data.valueProfit, 4)"></div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Открытых cделок осталось" field="openDealsCount" ></Column>

                </DataTable>
                <div class="mt-4">
                    <div class="text-xl mb-1">Суммарный профит: {{totalProfit}}</div>
                </div>
            </div>
            <div v-else>
                <p>Боты отсутствуют.</p>
            </div>
        </template>
    </Card>
</div>
</template>
